import { useEffect } from "react";
// react router dom
import { useNavigate, useParams } from "react-router-dom";

// dispatch
// import { useDispatch } from "react-redux";

// components
import { Table } from "../../components/Table/Table";
import { Badge } from "./managementStyle";

// styled components
import { Container } from "../../theme/GlobalStyle";
import { useChangeStatusSms, useGetListSms } from "../../hooks/useAccounting";
import { Spinner } from "reactstrap";

const ManagementSms = () => {
  const headerTitle = ["#", "نام", "وضعیت"];

  const navigate = useNavigate();

  const { data: listSms } = useGetListSms();

  const { id } = useParams();

  const { mutateAsync: changeStatus, isLoading: loadingSms } =
    useChangeStatusSms();

  const handleChangeStatusSms = async () => {
    await changeStatus(id);
  };

  const handleActivation = async (event, id) => {
    event.stopPropagation();
    await handleChangeStatusSms();
  };

  const items = listSms?.data?.sms_panels?.map((item, index) => (
    <tr
      key={item.IdSmsPanel}
      onClick={() =>
        navigate(`/dashboard/management/manaegmentSms/${item?.IdSmsPanel}`)
      }
    >
      <td>{index + 1}</td>
      <td>{item?.NameSmsPanel}</td>
      <td onClick={(event) => handleActivation(event, item?.IdSmsPanel)}>
        <Badge
          bgColor={`${
            item?.status?.color === "success" ? "#198754" : "#F1416C"
          } `}
          color="#fff"
        >
          {`${
            loadingSms ? (
              <Spinner animation="border" color="light" variant="light" />
            ) : (
              item?.status?.title
            )
          } `}
        </Badge>
      </td>
    </tr>
  ));

  return (
    <Container>
      <Table
        headerTitle={headerTitle}
        title="لیست پنل های پیامکی"
        items={items}
      />
    </Container>
  );
};

export default ManagementSms;
